import { render } from "./Piggybank.vue?vue&type=template&id=1f6e744d"
import script from "./Piggybank.vue?vue&type=script&lang=js"
export * from "./Piggybank.vue?vue&type=script&lang=js"
script.render = render

export default script